import { Plugin, Slot } from '../types';

const getKey = (widgetId: string, slotId: string) => `${widgetId}-${slotId}`;

export const canOpenModal = (plugins: Plugin[], slots: Slot[]): boolean => {
  if (!plugins.length || !slots.length) {
    return false;
  }

  const slotMap = new Map<string, boolean>();

  slots.forEach((slot) => {
    const key = getKey(slot.widgetId, slot.slotId);
    slotMap.set(key, true);
  });

  return plugins.every((plugin) =>
    plugin.placements.some((placement) => {
      const key = getKey(placement.widgetId, placement.slotId);
      return slotMap.has(key);
    }),
  );
};
